import React, { useState } from "react";
import "./PrivacyPolicy.css";
import Navbar from "./Navbar";
import Footer from "./Footer";

const sections = [
  {
    number: "01",
    title: "Introduction",
    content: `Welcome to NourTune. Your privacy is important to us. This Privacy Policy explains how our app handles information when you use our services.`,
  },
  {
    number: "02",
    title: "Information We Collect",
    content:
      "When you register and use NourTune, we collect the following information to provide our services:",
    list: [
      "Personal information you provide directly (name, email address, password)",
      "Profile information to customize your experience",
      "Device and usage data to improve app performance and reliability",
    ],
  },
  {
    number: "03",
    title: "How We Use Information",
    content: "We use the information collected to:",
    list: [
      "Create and manage your account",
      "Provide and improve our services",
      "Communicate important updates and offers",
      "Analyze usage patterns to enhance the app experience",
    ],
  },
  {
    number: "04",
    title: "Data Sharing",
    content:
      "We respect your privacy and do not sell your personal information. We may share your data only with trusted service providers or to comply with legal obligations.",
  },
  {
    number: "05",
    title: "Security",
    content: `We take reasonable measures to protect the information related to the operation of our app. However, no method of electronic storage or transmission over the internet is completely secure.`,
  },
  {
    number: "06",
    title: "Children's Privacy",
    content:
      "NourTune can be used by general audiences, including children. We do not knowingly collect personal information from children under 13. If we learn that such information has been collected, it will be deleted promptly.",
  },
  {
    number: "07",
    title: "Third-Party Services",
    content: `Our app may use third-party services that may collect limited information. These services follow their own privacy policies.`,
  },
  {
    number: "08",
    title: "Policy Updates",
    content: `We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.`,
  },
  {
    number: "09",
    title: "Contact Us",
    content:
      "If you have any questions about this Privacy Policy, please contact us at:",
    email: "support@nourtune.com",
  },
];

const PrivacyPolicy = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="light">
      <Navbar />
      <div className="privacy-policy-container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <div className="effective-date">Effective March 10, 2026</div>
        </div>

        <div className="privacy-grid">
          {sections.map((section, index) => (
            <div key={index} className="policy-section">
              <button
                className={`privacy-title ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleSection(index)}
              >
                <div className="title-text">
                  <span className="privacy-number">{section.number}</span>
                  <span>{section.title}</span>
                </div>
                <span className="arrow-icon">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              <div
                className={`privacy-content ${openIndex === index ? "open" : ""}`}
              >
                <div className="content-inner">
                  <p>{section.content}</p>
                  {section.list && (
                    <ul className="content-list">
                      {section.list.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  )}
                  {section.email && (
                    <a
                      href={`mailto:${section.email}`}
                      className="contact-email"
                    >
                      {section.email}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
